import type { FC, KeyboardEvent } from 'react';
import React from 'react';

import { ExternalLinkIcon } from '../../assets/icons/icons';
import styles from './MaxCard.module.scss';
import { QrCode } from '../../assets/qrCode';

interface MaxCardProps {
    onOpenMax: () => void;
    onOpenQr: () => void;
}

export const MaxCard: FC<MaxCardProps> = ({ onOpenMax, onOpenQr }) => {
    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>): void => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        onOpenQr();
    };

    return (
        <div className={styles.card}>
            <div className={styles.copy}>
                <div className={styles.title}>Связь в мессенджере MAX</div>

                <p className={styles.desc}>
                    Создавайте обращения, задавайте вопросы по проектам в мессенджере MAX
                </p>

                <button type="button" className={styles.open} onClick={onOpenMax}>
                    <ExternalLinkIcon />
                    Перейти в MAX
                </button>
            </div>

            <div
                className={styles.qr}
                role="button"
                tabIndex={0}
                aria-label="Увеличить QR-код MAX"
                onClick={onOpenQr}
                onKeyDown={handleKeyDown}
            >
                <QrCode role="img" aria-label="QR-код для перехода в MAX" />
            </div>
        </div>
    );
};